/**
 * Bot-scoped Studio paths (sidebar + bot overview). Keep in sync with
 * `resolveSidebarContext` query routes in `sidebarContext.ts`.
 */

export function botAnalyticsHref(botId: string, tenantId: string | null): string {
  const q = new URLSearchParams({ botId });
  if (tenantId) q.set('tenantId', tenantId);
  return `/analytics/bot?${q.toString()}`;
}

export function botReportingHref(botId: string, tenantId: string | null, role: string): string {
  const q = new URLSearchParams({ botId });
  if (tenantId && role === 'superadmin') q.set('tenantId', tenantId);
  return `/reporting?${q.toString()}`;
}

export function livechatHref(botId: string | null, tenantId: string | null, role: string): string {
  if (!botId) return '/livechat';
  const q = new URLSearchParams({ botId });
  if (tenantId && role === 'superadmin') q.set('tenantId', tenantId);
  return `/livechat?${q.toString()}`;
}

export function agentWorkspaceHref(botId: string | null, tenantId: string | null, role: string): string {
  if (!botId) return '/livechat/workspace';
  const q = new URLSearchParams({ botId });
  if (tenantId && role === 'superadmin') q.set('tenantId', tenantId);
  return `/livechat/workspace?${q.toString()}`;
}
